import { Output, EventEmitter, Input, OnInit, OnDestroy, Injectable, ChangeDetectorRef } from '@angular/core';

import { Subscription, Observable, Subject } from 'rxjs';

import { AbstractControl } from './control.types';
import { getControlEntityAttributes } from '../utils/control-helper';
import { QueryConditionSettingModel } from './query-condition-setting-model';
import { DynamicFormDesignerConfig } from '../utils/dynamic-form-designer-config';
import { HttpClient } from '@angular/common/http';

/**
 * @description æ½è±¡å±æ§ç¼è¾å¨
 *
 * @export
 */
export interface AbstractPropertyEditor {
  /**
   * æ¯å¦ç¦ç¨
   *
   */
  disabled: boolean;
  /**
   * @description æ§ä»¶å¼æ¹å
   *
   * @memberof AbstractPropertyEditor
   */
  valueChange: EventEmitter<any>;

  /**
   * æ§ä»¶å¼åå§å¼åå
   *
   * @memberof AbstractPropertyEditor
   */
  originValueChange: EventEmitter<any>;

  /**
   * @description å¯¹åºæ§ä»¶
   *
   * @memberof AbstractPropertyEditor
   */
  control: AbstractControl<any>;
  /**
   * @description æ é¢
   *
   * @memberof AbstractPropertyEditor
   */
  caption: string;
  /**
   * @description å±æ§åç§°
   *
   * @memberof AbstractPropertyEditor
   */
  propertyName: string;
  /**
   * @description å±æ§è®¾ç½®
   *
   * @memberof AbstractPropertyEditor
   */
  settings: { reg?: RegExp; regErrorMsg?: string };
  /**
   * @description å±æ§å¼
   *
   * @memberof AbstractPropertyEditor
   */
  value: any;

  /**
   * @description åå§åcontrolå¼
   *
   * @memberof AbstractPropertyEditor
   */
  initializeControlValue(value: any): void;
}

@Injectable()
export abstract class AbstractPropertyEditorBase<T = any> implements AbstractPropertyEditor {
  @Input()
  caption: string;

  @Input()
  settings: any = {};

  @Input()
  get control(): AbstractControl<any> {
    return this._control;
  }
  set control(value: AbstractControl<any>) {
    this._control = value;
  }

  @Input()
  get propertyName(): string {
    return this._propertyName;
  }
  set propertyName(value: string) {
    this._propertyName = value;
    // this.initializeControlValue();
  }

  @Input()
  get value(): T {
    return this._value;
  }
  set value(value: T) {
    this._value = value;

    this.afterSetControlValue(value);
  }
  @Input() disabled: boolean = false;

  @Output() valueChange: EventEmitter<T> = new EventEmitter<T>();
  @Output() originValueChange: EventEmitter<any> = new EventEmitter<any>();

  private _control: AbstractControl<any>;
  private _propertyName: string;
  private _value: T;

  constructor() {}

  /**
   * åå§åå¼ä¹å
   *
   * @memberof AbstractPropertyEditorBase
   */
  afterControlValueInit(): void {}

  /**
   * @description æ§ä»¶å¼æ¹åä¹å
   *
   * @memberof AbstractPropertyEditorBase
   */
  protected afterSetControlValue(value: any) {
    this.valueChange.emit(value);
  }

  initializeControlValue(value: any) {
    this._value = value;
    this.afterControlValueInit();
  }
}

@Injectable()
export abstract class QueryConditionPropertyEditorBase<T = any> extends AbstractPropertyEditorBase<T>
  implements OnInit, OnDestroy {
  get checked(): boolean {
    return this._checked;
  }
  set checked(value: boolean) {
    this._checked = value;
    this.afterSetControlValue(null);
  }

  get serialNo(): number {
    return this._serialNo;
  }
  set serialNo(value: number) {
    this._serialNo = value;
    this.afterSetControlValue(null);
  }

  get rule(): string {
    return this._rule;
  }
  set rule(value: string) {
    this._rule = value;
    this.afterSetControlValue(null);
  }

  @Input() set settings(settings: any) {
    this._settings = settings;
  }
  get settings() {
    return this._settings;
  }

  private _settings: any;

  rulesSetting: any = {};
  entityAttributesSetting: {
    items: { caption: string; name: string }[];
    displayMember: string;
    valueMember: string;
  } = { items: [], displayMember: 'caption', valueMember: 'name' };

  private _checked: boolean;
  private _serialNo: number;
  private _rule: string;
  private _controlEntityAttributeSubscription: Subscription;

  constructor() {
    super();
  }

  ngOnInit() {
    this.initRuleSettings();
    // æ¾å¨è¿éæ¯é¿åæ°æ®æåæ¥åï¼é ææ¾ç¤ºä¸æ­£ç¡®
    this.bindEntityAttributeChange();
  }

  ngOnDestroy(): void {
    if (this._controlEntityAttributeSubscription) {
      this._controlEntityAttributeSubscription.unsubscribe();
    }
  }

  initRuleSettings() {
    if (!this.settings.rules) {
      return;
    }
    const rules: Array<any> = [];
    for (const s of Object.keys(this.settings.rules)) {
      rules.push({ text: this.settings.rules[s], name: s });
    }
    this.rulesSetting.items = rules;
    this.rulesSetting.displayMember = 'text';
    this.rulesSetting.valueMember = 'name';
  }

  abstract afterSetControlValue(value: any): void;

  private bindEntityAttributeChange() {
    if (this.settings['entityAttributeChange$']) {
      this._controlEntityAttributeSubscription = (this
        .settings as QueryConditionSettingModel).entityAttributeChange$.subscribe((s) => {
        this.entityAttributesSetting = {
          items: getControlEntityAttributes(s.entityAttributes, this.control.model),
          displayMember: 'caption',
          valueMember: 'name'
        };
        this.afterEntityAttributeChange();
      });
    }
  }

  /**
   * å½å®ä½å±æ§åçåååï¼æ§è¡çæä½
   *
   * @protected
   *
   * @memberOf QueryConditionPropertyEditorBase
   */
  protected afterEntityAttributeChange() {}
}

/**
 * ä¸ææ¡ç¼è¾å¨è®¾ç½®
 *
 */
export interface DropDownPropertyEditorSetting<T> {
  items: T[];

  /**
   * å¼æ­¥è·åæ°æ®
   */
  getItemsAsync?: (
    designerConfig: DynamicFormDesignerConfig,
    httpClient: HttpClient,
    parent?: { target: AbstractControl<any>; value: any }
  ) => Observable<T[]>;

  /**
   * æ¯å¦å¼¹åºåå§æ°æ®
   */
  emitOriginData?: boolean;

  /**
   * å¼æ¹åäºä»¶
   */
  valueChanged: EventEmitter<{ target: AbstractControl<any>; value: T }>;

  /**
   * ä¸çº§éä¸­å¼
   *
   */
  parentValue?: any;

  /**
   * ä¸çº§å¼ååäºä»¶
   *
   */
  parentValueChanged?: Subject<{ target: AbstractControl<any>; value: any }>;

  /**
   * å¼æååç§°
   */
  valueMember: string;

  /**
   * æ¾ç¤ºæååç§°
   */
  displayMember: string;

  /**
   * æ¯å¦ä¿çåå§å¼
   */
  isKeepInitialValue?: boolean;

  init?: () => void;
}
